module.exports = __webpack_public_path__ + "img/img9.047047c3.jpg";